import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MeasurementUnitList from '../Pages/MeasurementUnits/MeasurementUnitList';
import MeasurementUnitAdd from '../Pages/MeasurementUnits/MeasurementUnitAdd';
import MeasurementUnitEdit from '../Pages/MeasurementUnits/MeasurementUnitEdit';
import MeasurementUnitView from '../Pages/MeasurementUnits/MeasurementUnitView';

/**
 * Routes for measurement unit CRUD operations
 * @param {Object} props - Component props
 * @returns {JSX.Element} MeasurementUnitRoutes component
 */
const MeasurementUnitRoutes = (props) => {
  const { match } = props;
  const { path } = match;
  
  return (
    <Switch>
      <Route exact path={`${path}`} component={MeasurementUnitList} />
      <Route exact path={`${path}/add`} component={MeasurementUnitAdd} />
      <Route exact path={`${path}/edit/:id`} component={MeasurementUnitEdit} />
      <Route exact path={`${path}/view/:id`} component={MeasurementUnitView} />
    </Switch>
  );
};

export default MeasurementUnitRoutes;
